<template>
  <div class="goods_vat_compare">
    <div class="layout">
      <back-button class="back-button" caption="ย้อนกลับ" />
    </div>

    <div class="gvc-body">
      <div class="gvcb-title">
        <div>
          <h3>
            เปรียบเทียบสภาพคล่อง<br />
            ทางการเงินของคุณ
          </h3>
          <div>จดหรือไม่จด VAT ดีกว่ากันนะ?</div>
        </div>
        <div class="gvcbt-wrapper" @click="goToEditInput">
          <img
            class="edit-blue"
            src="@/assets/icons/bx_bxs-edit-blue.svg"
            alt="bx_bxs-edit-blue"
          />
        </div>
      </div>

      <div class="gvcb-header">
        <div
          class="gvcbh-left"
          :class="[isRegister ? 'gvcbh-active' : '']"
          @click="isRegister = true"
        >
          <div class="gvcbh-block">
            <img v-if="isRegister" :src="CHECKPRIMARY1" alt="check-primary1" />
          </div>
          <h4>จด VAT</h4>
        </div>
        <div
          class="gvcbh-right"
          :class="[!isRegister ? 'gvcbh-active' : '']"
          @click="isRegister = false"
        >
          <div class="gvcbh-block">
            <img v-if="!isRegister" :src="CHECKPRIMARY1" alt="check-primary1" />
          </div>
          <h4>ไม่จด VAT</h4>
        </div>

        <div class="ab-bg-lightblue">
          <div
            class="bg-lightblue"
            :class="[isRegister ? 'focus-with-vat' : '']"
            style="margin-right: 7px"
          />
          <div
            class="bg-lightblue"
            :class="[!isRegister ? 'focus-with-vat' : '']"
            style="margin-left: 7px"
          />
        </div>
      </div>

      <div class="gvcb-row">
        <div class="gvcbr-topic">{{ labelIncome }}</div>
        <div class="gvcbr-detail">
          <div
            class="gvcbrd-left"
            :class="[isRegister ? 'gvcbrd-text-bold gvcbrd-link' : '']"
          >
            <currency
              mode="readOnly"
              v-model="withRegister.sellingPriceExcludeVat"
            />
          </div>
          <div
            class="gvcbrd-right"
            :class="[!isRegister ? 'gvcbrd-text-bold gvcbrd-link' : '']"
          >
            <currency
              mode="readOnly"
              v-model="withoutRegister.sellingPriceExcludeVat"
            />
          </div>
        </div>
      </div>

      <div class="gvcb-row">
        <div class="gvcbr-topic">ภาษีขาย</div>
        <div class="gvcbr-detail">
          <div
            class="gvcbrd-left"
            :class="[isRegister ? 'gvcbrd-text-bold' : '']"
          >
            <currency mode="readOnly" :value="withRegister.sellingVat" />
          </div>
          <div
            class="gvcbrd-right"
            :class="[!isRegister ? 'gvcbrd-text-bold' : '']"
          >
            <currency mode="readOnly" :value="withoutRegister.sellingVat" />
          </div>
        </div>
      </div>

      <div class="gvcb-row">
        <div class="gvcbr-topic">{{ labelCost }}</div>
        <div class="gvcbr-detail">
          <div
            class="gvcbrd-left"
            :class="[isRegister ? 'gvcbrd-text-bold gvcbrd-link' : '']"
          >
            <currency
              mode="readOnly"
              v-model="withRegister.purchasePriceExcludeVat"
            />
          </div>
          <div
            class="gvcbrd-right"
            :class="[!isRegister ? 'gvcbrd-text-bold gvcbrd-link' : '']"
          >
            <currency
              mode="readOnly"
              v-model="withoutRegister.purchasePriceExcludeVat"
            />
          </div>
        </div>
      </div>

      <div class="gvcb-row">
        <div class="gvcbr-topic">ภาษีซื้อ</div>
        <div class="gvcbr-detail">
          <div
            class="gvcbrd-left"
            :class="[isRegister ? 'gvcbrd-text-bold' : '']"
          >
            <currency mode="readOnly" :value="withRegister.purchaseVat" />
          </div>
          <div
            class="gvcbrd-right"
            :class="[!isRegister ? 'gvcbrd-text-bold' : '']"
          >
            <currency mode="readOnly" :value="withoutRegister.purchaseVat" />
          </div>
        </div>
      </div>

      <div class="gvcb-row">
        <div class="gvcbr-topic">ภาษีนำส่ง</div>
        <div class="gvcbr-detail">
          <div
            class="gvcbrd-left"
            :class="[isRegister ? 'gvcbrd-text-bold' : '']"
          >
            <currency mode="readOnly" :value="withRegister.vat" />
          </div>
          <div
            class="gvcbrd-right"
            :class="[!isRegister ? 'gvcbrd-text-bold' : '']"
          >
            <currency mode="readOnly" :value="withoutRegister.vat" />
          </div>
        </div>
      </div>

      <div class="gvcb-row">
        <div class="gvcbr-topic">เงินคงเหลือ</div>
        <div class="gvcbr-detail">
          <div
            class="gvcbrd-left"
            :class="[isRegister ? 'gvcbrd-text-bold' : '']"
          >
            <currency mode="readOnly" :value="withRegister.netCash" />
          </div>
          <div
            class="gvcbrd-right"
            :class="[!isRegister ? 'gvcbrd-text-bold' : '']"
          >
            <currency mode="readOnly" :value="withoutRegister.netCash" />
          </div>
        </div>
      </div>

      <div class="gvcb-next">
        <chevron-right-link
          @clickLink="goCorpDefinition"
          caption="ดูคำอธิบายเพิ่ม"
        />
      </div>
      <h3 class="label-summary" v-if="isRegister">สรุปแล้วถ้าจด VAT คุณจะ</h3>
      <h3 class="label-summary" v-else>สรุปแล้วถ้าไม่จด VAT คุณจะ</h3>
      <div
        class="gvcb-status"
        v-if="isRegister && withRegister.netCash - withoutRegister.netCash > 0"
      >
        <img
          class="gvcbs-background"
          :src="BACKGROUNDSUCCESS"
          alt="background-success"
        />
        <div class="gvcbs-text">
          <h4>เงินคงเหลือมากกว่า</h4>
          <h1>
            <currency mode="readOnly" :value="difference" />
          </h1>
        </div>
      </div>
      <div class="gvcb-status" v-else>
        <img
          class="gvcbs-background"
          :src="BACKGROUNDERROR"
          alt="background-success"
        />
        <div class="gvcbs-text">
          <h4>เงินคงเหลือน้อยกว่า</h4>
          <h1>
            <currency mode="readOnly" :value="difference" />
          </h1>
        </div>
      </div>

      <div class="gvcb-footer">
        <div class="gvcb-detail">
          การมีเงินคงเหลือมากจะส่งผลดี
          <br />
          และเพิ่มโอกาสเติบโตในธุรกิจของคุณ
        </div>

        <material-button
          class="gvcb-button"
          :id="nextButtonId"
          @clickButton="goToSummaries"
        >
          ดู tax checklist ของคุณ
        </material-button>

        <material-button
          class="gvcb-button button-secondary"
          @clickButton="goChangeProcess"
        >
          มีเรื่องอะไรควรรู้อีกบ้าง
        </material-button>
      </div>
    </div>
    <StateAnswer />
  </div>
</template>

<script>
import CHECKPRIMARY1 from "@/assets/icons/check-primary1.svg";
import BACKGROUNDSUCCESS from "@/assets/icons/background-success.svg";
import BACKGROUNDERROR from "@/assets/icons/background-error.svg";
import ALERTICON from "@/assets/images/eva_alert-triangle-outline.png";

import StateAnswer from "@/components/StateAnswer.vue";

export default {
  name: "VatRegisterCompare",
  components: {
    StateAnswer,
  },
  data() {
    const isRegister = this.$store.getters["questions/getAnswers"]
      .isRegisteredVat;
    const taxType = this.$store.getters["questions/getAnswers"].taxType;
    const isRegisteredVat = this.$store.getters["questions/getAnswers"]
      .isRegisteredVat;

    const labelIncome = "รายได้จากการขายสินค้าต่อปี";
    const labelCost = "ต้นทุนสินค้าต่อปี";

    return {
      labelIncome,
      labelCost,
      isRegister,
      CHECKPRIMARY1,
      ALERTICON,
      taxType,
      isRegisteredVat,
      BACKGROUNDERROR,
      BACKGROUNDSUCCESS,
    };
  },
  methods: {
    goToSummaries() {
      if (this.taxType === "personal") {
        this.$router.push({
          path: "/summaries/personal_not_register",
        });
      } else {
        this.$router.push({
          path: "/summaries/corp_not_register",
        });
      }
    },
    goCorpDefinition() {
      this.$router.push({
        path: "/info/corp_vat_definition",
      });
    },
    goChangeProcess() {
      this.$router.push({ path: "/info/change_process" });
    },
    goToEditInput() {
      this.$router.push({
        path: "/forms/register_vat_input_edit",
      });
    },
  },
  computed: {
    nextButtonId: function () {
      let id = !this.isRegisteredVat ? "not-register" : "registered";
      let id2 = !this.isRegister ? "-not-register" : "-registered";

      return id + id2;
    },
    withRegister: function () {
      const taxType = this.$store.getters["questions/getAnswers"].taxType;
      const withRegister =
        taxType === "personal"
          ? this.$store.getters["vatCompare/getPersonalRegisterVat"]
          : this.$store.getters["vatCompare/getCorporateRegisterVat"];

      return withRegister;
    },
    withoutRegister: function () {
      const taxType = this.$store.getters["questions/getAnswers"].taxType;
      const withoutRegister =
        taxType === "personal"
          ? this.$store.getters["vatCompare/getPersonalNotRegisterVat"]
          : this.$store.getters["vatCompare/getCorporateNotRegisterVat"];
      return withoutRegister;
    },
    difference: function () {
      const value = Math.max(
        0,
        this.withRegister.netCash - this.withoutRegister.netCash
      );
      return value;
    },
  },
};
</script>

<style scoped>
.goods_vat_compare {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.layout {
  width: 100%;
  padding: 0px 30px;
  max-width: 1120px;
  box-sizing: border-box;
}
.gvc-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  position: relative;
  margin-bottom: 26px;
  max-width: 544px;
}
.gvcb-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
  text-align: left;
  padding: 0px 30px;
  box-sizing: border-box;
}
.red {
  color: #f45a49;
}
.card {
  display: flex;
  width: 100%;
  margin-bottom: 21px;
  max-width: 352px;
  justify-content: center;
  border: 1px solid #f45a49;
  border-radius: 5px;
}
.card-content {
  width: 100%;
  display: flex;
  max-width: 330px;
  padding: 0 11px;
  text-align: left;
}
.card-img {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 18px;
}
.card-detail {
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 17px;
}
.gvcbt-wrapper {
  cursor: pointer;
}
.gvcb-header {
  width: 100%;
  display: flex;
  height: 56px;
  margin-bottom: 16px;
  justify-content: space-between;
  position: relative;
}

.ab-bg-lightblue {
  position: absolute;
  top: 56px;
  width: 100%;
  height: 525px;
  display: flex;
  justify-content: space-between;
}

.bg-lightblue {
  flex: 1;
  max-width: 256px;
}
.focus-with-vat {
  background: #99d6f1;
  opacity: 0.1;
}

.gvcbh-block {
  width: 24px;
  height: 24px;
  background: #ffffff;
  margin-right: 16px;
  border-radius: 2px;
}
.gvcbh-left {
  flex: 1;
  background: #acb1bf;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 7px;
  color: #ffffff;

  cursor: pointer;
  max-width: 256px;
  box-sizing: border-box;
}
.gvcbh-right {
  flex: 1;
  background: #acb1bf;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 7px;
  color: #ffffff;

  cursor: pointer;
  max-width: 256px;
  box-sizing: border-box;
}
.gvcbh-active {
  background: #29a9e2;
}

.gvcb-row {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;

  padding: 0px 30px;
  box-sizing: border-box;
  background: transparent;
}
.gvcbr-topic {
  width: 100%;
  display: flex;
  align-items: center;
  text-align: left;
  color: #acb1bf;
  border-bottom: 1px solid #d8d9e0;
  margin-bottom: 8px;
  background: transparent;
}
.gvcbr-detail {
  width: 100%;
  display: flex;
  background: transparent;
  justify-content: space-between;
}
.gvcbr-detail > div {
  flex: 1;
  text-align: right;
}
.gvcbrd-left {
  margin-right: 7px;
  max-width: 232px;
  padding-right: 20px;
}

.gvcbrd-right {
  margin-left: 7px;
  max-width: 232px;
}
.gvcbrd-text-bold,
.gvcbrd-text-bold * {
  font-weight: bold;
}

.gvcbrd-link {
  text-decoration: underline;
  color: #29a9e2;
}

.gvcb-next {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin-top: 16px;

  padding: 0px 24px;
  box-sizing: border-box;
}

.gvcb-status {
  width: 100%;
  max-width: 351px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 191px;
  margin-top: 34px;
  margin-bottom: 31px;
}
.gvcbs-background {
  position: absolute;
  z-index: -1;
}
.gvcbs-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}
.gvcbs-text * {
  color: #ffffff !important;
  max-width: 220px;
}
.gvcbs-text h4 {
  font-size: 19px;
}
.gvcbs-text h1,
.gvcbs-text h1 input {
  font-size: 34px;
  text-align: center;
}

.gvcb-footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  padding: 0px 24px;
  box-sizing: border-box;
}

.gvcb-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 24px;
}

.gvcb-button {
  max-width: 352px;
  margin-bottom: 14px;
}
.back-button {
  margin: 24px 0;
}
.label-summary {
  margin-top: 48px;
}
/*size  >768px */
@media only screen and (min-width: 769px) {
  .gvcb-row,
  .gvcb-next,
  .gvcb-footer {
    padding: 0px;
  }
  .gvcbh-left,
  .gvcbh-right {
    padding: 0px 24px;
    justify-content: flex-start;
  }
  .gvcbrd-left,
  .gvcbrd-right {
    max-width: 232px;
    max-width: 256px;
    margin-right: 0px;
    margin-left: 0px;
  }
  .layout {
    padding: 0;
  }
  .back-button {
    margin-bottom: 0;
  }

  .gvcb-row {
    padding: 0;
  }

  .gvcbr-topic {
    padding: 0px 30px;
    box-sizing: border-box;
  }
  .gvcbrd-left,
  .gvcbrd-right {
    padding: 0 20px;
    box-sizing: border-box;
  }
}
</style>
